// extracted by mini-css-extract-plugin
module.exports = {"not-found":"NotFound_not-found__mIkxh","not-found__hero":"NotFound_not-found__hero__skBl_"};